import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Link from '~/components/Link';
import * as FormStyled from '~/components/Form/styles';
import routesPath from '~/constants/routes';
import * as S from './styles';
import DefaultLayout from '~/pages/_layouts/DefaultLayout';
import { resendEmailRequest } from '~/store/modules/auth/actions';
import { languageOptions } from '~/utils/languageOptions';
import FoldedMenu from '~/components/FoldedMenu';

export default function RegisterConfirmation() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [emailConfirmation, setEmailConfirmation] = useState(null);
  const { loading } = useSelector(state => state.auth);

  useEffect(() => {
    setEmailConfirmation({
      email: localStorage.getItem('email-confirmation'),
    });
  }, []);

  return (
    <DefaultLayout>
      <S.Container width={30} position="flex-start">
        <FormStyled.Logo />
        <FormStyled.FormTitle>{t('registerConfirmation')}</FormStyled.FormTitle>

        <S.FloatingMessage>
          <p>{t('registerConfirmationMessage')}</p>
        </S.FloatingMessage>

        <FormStyled.Aligner>
          <FormStyled.SubmitButton
            disabled={loading || emailConfirmation === null}
            onClick={() => {
              dispatch(resendEmailRequest(emailConfirmation));
            }}
          >
            {loading ? `${t('loading')}...` : t('sendEmailAgain')}
          </FormStyled.SubmitButton>
        </FormStyled.Aligner>

        <FormStyled.Return>
          <Link
            to={routesPath.login}
            onClick={() => {
              setEmailConfirmation('');
              localStorage.removeItem('email-confirmation');
            }}
          >
            {t('return')}
          </Link>
        </FormStyled.Return>
      </S.Container>
      <FoldedMenu label={t('languageId')} options={languageOptions()} />
    </DefaultLayout>
  );
}
